import "./FrameComponent4.css";

const FrameComponent4 = () => {
  return (
    <div className="navbar-parent3">
      <header className="navbar4">
        <div className="title4">
          <h1 className="heading4">Seller profile</h1>
          <div className="sub4">Here’s your dashboard overview.</div>
          <div className="breadcrumbs4">
            <div className="contract16">Contract</div>
            <img className="icon64" alt="" src="/icon-8.svg" />
            <div className="contract17">General Info</div>
            <img className="icon65" alt="" src="/icon-8.svg" />
            <div className="contract18">Scope of Work</div>
            <img className="icon66" alt="" src="/icon-8.svg" />
            <div className="contract19">Payment Details</div>
            <img className="icon67" alt="" src="/icon-8.svg" />
            <div className="general-info4">Sign</div>
          </div>
        </div>
        <div className="right-menu5">
          <div className="button17">
            <img className="icon68" alt="" src="/icon1.svg" />
            <div className="create-a-contract8">CREATE</div>
            <img className="icon69" alt="" src="/icon1.svg" />
          </div>
          <div className="icon70">
            <img className="icon71" alt="" src="/icon-13.svg" />
          </div>
          <div className="user4">
            <div className="avatar5">
              <img
                className="image-icon5"
                loading="lazy"
                alt=""
                src="/image@2x.png"
              />
              <img className="check-icon5" alt="" src="/check.svg" />
            </div>
            <div className="text41">
              <div className="chris-miguel5">Chris Miguel</div>
              <div className="freelancer5">Freelancer</div>
            </div>
          </div>
        </div>
      </header>
      <div className="arch-finance-ltd-wrapper">
        <h1 className="arch-finance-ltd1">ARCH Finance LTD</h1>
      </div>
    </div>
  );
};

export default FrameComponent4;
